import React, { useState } from 'react';
import { Building2, Megaphone } from 'lucide-react';
import AgencyManager from './AgencyManager';
import AnnouncementsManager from './AnnouncementsManager';

const AgenciesWrapper = () => {
  const [activeTab, setActiveTab] = useState('agencies'); // agencies or announcements

  return (
    <div className="min-h-screen bg-gray-900">
      {/* Main Heading */}
      <div className="mb-6">
        <h1 className="text-3xl font-black text-white">AGENCIES & ANNOUNCEMENTS</h1>
        <p className="text-gray-400 mt-1">Manage travel agencies, partners, and platform announcements</p>
      </div>

      {/* Tab Navigation */}
      <div className="bg-gray-800 border-b border-gray-700 mb-6">
        <div className="flex space-x-1">
          <button
            onClick={() => setActiveTab('agencies')}
            className={`flex items-center space-x-2 px-6 py-4 font-medium transition-colors border-b-2 ${
              activeTab === 'agencies'
                ? 'text-yellow-400 border-yellow-400 bg-gray-900/50'
                : 'text-gray-400 border-transparent hover:text-white hover:bg-gray-700/50'
            }`}
          >
            <Building2 size={20} />
            <span>Agencies</span>
          </button>
          <button
            onClick={() => setActiveTab('announcements')}
            className={`flex items-center space-x-2 px-6 py-4 font-medium transition-colors border-b-2 ${
              activeTab === 'announcements'
                ? 'text-yellow-400 border-yellow-400 bg-gray-900/50'
                : 'text-gray-400 border-transparent hover:text-white hover:bg-gray-700/50'
            }`}
          >
            <Megaphone size={20} />
            <span>Announcements</span>
          </button>
        </div>
      </div>

      {/* Content */}
      <div>
        {activeTab === 'agencies' && <AgencyManager />}
        {activeTab === 'announcements' && <AnnouncementsManager />}
      </div>
    </div>
  );
};

export default AgenciesWrapper;
